import React, { useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Flex,
  FormLabel
} from "@chakra-ui/react";
import CustomReactSelect from "../general/form/CustomReactSelect";
import CloseModalArrow from "../general/CloseModalArrow";

const NewReportModal = ({ isOpen, onClose, funds, onSubmit }) => {
  const [selectedFund, setSelectedFund] = useState(null);
  const [selectedReportType, setSelectedReportType] = useState(null);

  const reportTypes = [
    { value: "Annex IV", label: "Annex IV" },
    { value: "Risk", label: "Risk" },
    { value: "ESG", label: "ESG" },
    { value: "Valuation", label: "Valuation" },
    { value: "AIFM", label: "AIFM" },
    { value: "Portfolio Management", label: "Portfolio Management" },
    { value: "Custom", label: "Custom" },
  ];

  const handleSubmit = () => {
    if (selectedFund && selectedReportType) {
      onSubmit({ fund: selectedFund, reportType: selectedReportType });
      onClose();
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent borderRadius={16}>
        <ModalHeader gap={4} alignItems={"center"}><CloseModalArrow onClose={onClose} />Create New Report</ModalHeader>
        <ModalBody>
          <Flex direction="column" gap={4}>
            {/* Select Fund */}
            <Flex direction="column">
              <FormLabel htmlFor="fundSelect">Select Fund</FormLabel>
              <CustomReactSelect
                id="fundSelect"
                options={funds.map((fund) => ({
                  value: fund.fundName, // Adjust based on your data structure
                  label: fund.fundName, // Adjust based on your data structure
                }))}
                placeholder="Search and select fund"
                onChange={(selected) => setSelectedFund(selected)}
              />
            </Flex>

            {/* Select Report Type */}
            <Flex direction="column">
              <FormLabel htmlFor="reportType">Select Report Type</FormLabel>
              <CustomReactSelect
                id="reportType"
                options={reportTypes}
                placeholder="Select report type"
                onChange={(selected) => setSelectedReportType(selected)}
              />
            </Flex>
          </Flex>
        </ModalBody>
        <ModalFooter gap={2}>
          <Button variant="ghost" onClick={onClose}>
            Cancel
          </Button>
          <Button
            colorScheme="brand"
            onClick={handleSubmit}
            isDisabled={!selectedFund || !selectedReportType}
          >
            Create Report
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default NewReportModal;
